import React from "react";
import { motion } from "framer-motion";
import { startCheckout } from "@/lib/checkout";
import { ArrowRight } from "lucide-react";

const rows = [
  { label: "Origem das acusações", d: "Contexto investigativo e indícios iniciais." },
  { label: "Processo judicial", d: "Trâmite nas instâncias e provas." },
  { label: "Decisões tomadas", d: "Sentenças e recursos ao longo do caso." },
  { label: "Desdobramentos posteriores", d: "Revisões, anulações e novos entendimentos." },
];

export default function TriplexSection() {
  return (
    <section id="triplex" className="relative py-24 md:py-36 bg-black border-t border-white/5 overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5 relative">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="relative aspect-[3/4] overflow-hidden border border-white/10"
          >
            <img
              src="https://images.unsplash.com/photo-1430285561322-7808604715df?w=1200&q=80"
              alt="Edifícios à beira-mar"
              className="w-full h-full object-cover"
              style={{ filter: "grayscale(100%) contrast(1.2) brightness(0.6)" }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
            {/* floorplan sketch overlay */}
            <svg viewBox="0 0 400 500" className="absolute inset-0 w-full h-full opacity-50">
              <rect x="60" y="80" width="280" height="340" stroke="#dc2626" strokeWidth="1.5" fill="none" />
              <line x1="60" y1="200" x2="340" y2="200" stroke="#dc2626" strokeWidth="1" strokeDasharray="4 4" />
              <line x1="60" y1="320" x2="340" y2="320" stroke="#dc2626" strokeWidth="1" strokeDasharray="4 4" />
              <line x1="200" y1="80" x2="200" y2="420" stroke="#dc2626" strokeWidth="1" strokeDasharray="4 4" />
            </svg>
            <div className="absolute top-4 left-4 font-mono text-[10px] tracking-[0.3em] uppercase text-red-500">
              Planta · referência editorial
            </div>
          </motion.div>
        </div>

        <div className="lg:col-span-7">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-[1px] w-10 bg-red-600" />
            <span className="eyebrow">Dossiê · Capítulo 03 · 2017</span>
          </div>
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="font-display font-black leading-[0.9] tracking-[-0.03em] text-5xl md:text-7xl text-neutral-50"
          >
            O caso do <span className="text-red-600 italic">Triplex</span> do Guarujá.
          </motion.h2>
          <p className="mt-6 max-w-xl text-neutral-400 leading-relaxed">
            Entenda a origem das acusações, o processo judicial, as decisões tomadas ao longo do caso
            e os acontecimentos jurídicos posteriores. O capítulo distingue claramente acusações,
            decisões judiciais e desdobramentos subsequentes.
          </p>

          <div className="mt-10 border border-white/10">
            {rows.map((r, i) => (
              <motion.div
                key={r.label}
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1, duration: 0.6 }}
                className="grid grid-cols-[80px_1fr_auto] md:grid-cols-[100px_1fr_auto] gap-4 items-center p-5 border-b border-white/5 last:border-b-0 hover:bg-red-950/10 transition-colors"
              >
                <div className="font-mono text-[11px] tracking-[0.25em] text-red-500">
                  0{i + 1}
                </div>
                <div>
                  <div className="font-display text-lg md:text-xl text-neutral-50">{r.label}</div>
                  <div className="text-[13px] text-neutral-500">{r.d}</div>
                </div>
                <div className="h-5 w-5 border border-red-600/60 rotate-45" />
              </motion.div>
            ))}
          </div>

          <button
            onClick={startCheckout}
            className="mt-10 inline-flex items-center gap-3 bg-red-600 hover:bg-red-700 text-white h-12 px-6 font-mono tracking-[0.25em] text-[11px] uppercase transition-colors"
          >
            Conhecer o capítulo <ArrowRight className="h-4 w-4" />
          </button>
        </div>
      </div>
    </section>
  );
}
